// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"27":"fb423778","58":"f437db54","291":"b7242710","354":"e4f7a617","647":"44d6aef3","656":"4f68fa88","718":"865dac2d","745":"303df869","783":"369bd01c","963":"678e9db5"}[chunkId] + ".chunk.css";
};